import { render } from "./ContentChannelItemList.vue?vue&type=template&id=6fc54174"
import script from "./ContentChannelItemList.vue?vue&type=script&lang=js"
export * from "./ContentChannelItemList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__